/**
 * This file is a component for E2 UI Customization (This is subject to change based off of mediaType)
 */

import React, {useState, useEffect} from 'react';
import { Grid, FormControlLabel, Checkbox, Tooltip} from '@material-ui/core';
import NoteOutlinedIcon from '@material-ui/icons/NoteOutlined';

export default function WorkItemActivityPanel(props)
{
    const [workItemActivityPanel, setWorkItemActivityPanel] = useState(false);

    /** Set disposition to value being passed through props */
    useEffect(() => {
        setWorkItemActivityPanel(props.value);
    },[props.value])

    // Handle hold checkbox change
    const handleWorkItemActivityPanel = () => {
        setWorkItemActivityPanel(!workItemActivityPanel);
        props.onChange(!workItemActivityPanel);
    }

    return(
        <div>
            <Grid container direction="row" alignItems="center">
                <Grid item>
                    <FormControlLabel
                    control={
                        <Checkbox
                        checked={workItemActivityPanel}
                        onChange={handleWorkItemActivityPanel}
                        name="workItemActivityPanel"
                        color="primary"
                        />
                    }
                    label="Activity Panel"
                    />
                </Grid>
                <Grid item>
                    <Tooltip title="Give permission for work item activity panels">
                        <NoteOutlinedIcon color="primary"/>
                    </Tooltip>
                </Grid>

            </Grid>
            
        </div>
    );
}

